rjm.ui.ChartBuilderCohortSizeView = rjm.ui.ChartBuilderDropdownView.extend(
  id: "cbCohortSize"
  className: "span clearfix"

  events:
    "click #saveCohortSize": "save"
    "click .btn.dropdown-toggle.cohortSize": "toggleDropdown"
    "input #intervalsPerPoint" : "validateInput"
    "input #cohortSize" : "validateInput"

  initialize: (options) ->
    if not options or not options.chartModel
      throw "InvalidConstructorArgs - ChartBuilderCohortSizeView"

    _.bindAll this, "save", "isValid", "validateInput", "generateTemplateData", "toggleDropdown", "render"
    @chartModel = options.chartModel
    @dataLimit = @chartModel.get("dataLimit")
    @cohortDescriptor = @chartModel.getCurrentSeries().get("cohortDescriptor")

    @listenTo @cohortDescriptor, "change:timeInterval", @render

    return

  save: (e) ->
    if not @isValid()
      return
    @dataLimit.set size: parseInt($('#cohortSize').val())
    @cohortDescriptor.set intervalsPerPoint: parseInt($('#intervalsPerPoint').val())
    @render()
    return

  isValid: ->
    return $('#intervalsPerPoint').val() isnt "" and $('#cohortSize').val() isnt "" and
      parseInt($('#cohortSize').val()) > 0 and parseInt($('#intervalsPerPoint').val()) > 0

  validateInput: (e) ->
    if @isValid()
      @$("#saveCohortSize").removeClass("disabled")
    else
      @$("#saveCohortSize").addClass("disabled")

  generateTemplateData: -> 
    timeIntervals = {}
    _(rjm.app.enums.timeInterval).each (interval, key) ->
      unless key is "SECOND"
        newInterval = {}
        newInterval.name = interval.names + "(s)"
        timeIntervals[key] = newInterval

    return out =
      timeInterval: timeIntervals[@cohortDescriptor.get('timeInterval')] 
      cohortSize: if @dataLimit.has("size") then @dataLimit.get('size') else null
      intervalsPerPoint: @cohortDescriptor.get("intervalsPerPoint")
      totalSize: if @dataLimit.has("size") then @dataLimit.get('size') * @cohortDescriptor.get("intervalsPerPoint") else null

  toggleDropdown: (e) ->
    e?.preventDefault()
    $(e.target).find('~.dropdown-menu').toggle()

  render: ->
    $(@el).html ich.chartBuilderCohortSize(@generateTemplateData())

    return @

)
